import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente dopo il pagamento ricevi un link per scaricare tutti i file. Accesso immediato, nessuna attesa. Puoi usare i materiali già dalla prossima lezione.'
}, {
  q: 'Funziona sia per il Biennio che per il Triennio?',
  a: "Sì. Il Metodo copre l'intero percorso ITE: dal Biennio al Triennio, dalla Partita Doppia alla Seconda Prova della Maturità."
}, {
  q: 'Il programma è allineato al MIM?',
  a: "Sì. Ogni volume è strutturato secondo le Indicazioni Nazionali, il PECUP e il Quadro di Riferimento del Ministero dell'Istruzione e del Merito 2025/2026."
}, {
  q: 'Cosa succede se ho studenti con BES o DSA?',
  a: 'Il Bonus 3 include griglie differenziate, mappe compensative e template PDP già strutturati per ogni unità didattica.'
}, {
  q: 'I materiali sono editabili?',
  a: 'Sì. Tutti i file sono modificabili in Word, Excel e PowerPoint. Adattali alla tua classe in pochi minuti.'
}, {
  q: 'Il pagamento è sicuro?',
  a: 'Sì. Pagamento sicuro tramite Stripe. Nessun costo nascosto. Pagamento unico, accesso a vita.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-12 uppercase text-brand-cream" data-id="element-86">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-4" data-id="element-87">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors" data-id="element-89">
                <span className="font-bold text-brand-cream pr-4" data-id="element-90">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-91" />
              </button>

              <AnimatePresence data-id="element-92">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-93">
                    <div className="px-6 pb-5 pt-0 text-gray-400 font-medium leading-relaxed" data-id="element-94">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}